import { match as address } from "../../../src/params/address.ts";
import { match as assetTypeId } from "../../../src/params/assetTypeId.ts";
import { match as swap_amount } from "../../../src/params/swap_amount.ts";
import { match as transaction_amount } from "../../../src/params/transaction_amount.ts";
import { match as transaction_asset_id } from "../../../src/params/transaction_asset_id.ts";
import { match as withdraw_asset_type_id } from "../../../src/params/withdraw_asset_type_id.ts";

export const matchers = { address, assetTypeId, swap_amount, transaction_amount, transaction_asset_id, withdraw_asset_type_id };